(() => {
  'use strict';
  const root = window.Shopify?.routes?.root || '/';
  document.addEventListener('click', event => {
    if (event.target.closest('#cart-icon-bubble')) event.stopImmediatePropagation();
  }, true);
  const storageKey = 'digital-pattern-favorites-v1';
  const validHandle = value => typeof value === 'string' && /^[a-z0-9][a-z0-9-]{0,254}$/.test(value);
  let favorites = [];
  let storageAvailable = true;
  try {
    const stored = JSON.parse(localStorage.getItem(storageKey) || '[]');
    if (Array.isArray(stored)) favorites = [...new Set(stored.filter(validHandle))];
  } catch (_) { storageAvailable = false; }
  let toastTimer;
  function notify(message) {
    let node = document.querySelector('.ds-toast');
    if (!node) { node = document.createElement('div'); node.className = 'ds-toast'; node.setAttribute('role', 'status'); document.body.append(node); }
    node.textContent = message; node.hidden = false;
    clearTimeout(toastTimer); toastTimer = setTimeout(() => { node.hidden = true; }, 3500);
  }
  function syncHearts() {
    document.querySelectorAll('[data-favorite]').forEach(button => {
      const active = favorites.includes(button.dataset.favorite);
      button.setAttribute('aria-pressed', String(active));
      button.setAttribute('aria-label', active ? 'Remove from favorites' : 'Save to favorites');
    });
    document.querySelectorAll('[data-favorite-count]').forEach(node => { node.textContent = favorites.length; node.hidden = favorites.length === 0 && node.classList.contains('ds-heart-count'); });
  }
  function persistFavorites() {
    try { localStorage.setItem(storageKey, JSON.stringify(favorites)); storageAvailable = true; }
    catch (_) { storageAvailable = false; }
    syncHearts();
  }
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-favorite]');
    if (!button) return;
    event.preventDefault();
    const handle = button.dataset.favorite;
    if (!validHandle(handle)) return;
    const removing = favorites.includes(handle);
    favorites = removing ? favorites.filter(item => item !== handle) : [...favorites, handle];
    persistFavorites();
    notify(storageAvailable ? (removing ? 'Removed from favorites' : 'Saved to favorites') : 'Browser storage is unavailable. Favorites will last only for this page visit.');
    if (document.querySelector('[data-favorites-page]')) renderFavorites();
  });
  window.addEventListener('storage', event => {
    if (event.key !== storageKey && event.key !== null) return;
    try { const data = JSON.parse(event.newValue || '[]'); favorites = Array.isArray(data) ? [...new Set(data.filter(validHandle))] : []; } catch (_) { favorites = []; }
    syncHearts(); renderFavorites();
  });
  function element(tag, className, text) {
    const node = document.createElement(tag); if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  }
  function safeImage(value) {
    if (!value) return null;
    try { const url = new URL(typeof value === 'string' ? value : value.src, location.origin); return ['https:', 'http:'].includes(url.protocol) ? url.href : null; } catch (_) { return null; }
  }
  const productCache = new Map();
  async function getProduct(handle) {
    if (productCache.has(handle)) return productCache.get(handle);
    const response = await fetch(`${root}products/${encodeURIComponent(handle)}.js`);
    if (!response.ok) throw new Error('Product unavailable');
    const product = await response.json(); productCache.set(handle, product); return product;
  }
  let renderVersion = 0;
  async function renderFavorites() {
    const page = document.querySelector('[data-favorites-page]'); if (!page) return;
    const version = ++renderVersion;
    const grid = page.querySelector('[data-favorites-grid]');
    const status = page.querySelector('[data-favorites-status]');
    page.querySelector('[data-favorites-empty]').hidden = favorites.length !== 0;
    status.textContent = favorites.length ? 'Loading your saved patterns…' : '';
    const handles = [...favorites];
    const results = await Promise.allSettled(handles.map(getProduct));
    if (version !== renderVersion) return;
    grid.replaceChildren();
    let missing = 0;
    results.forEach((result, index) => {
      const handle = handles[index]; const card = element('article', 'ds-favorite-card');
      const heart = element('button', 'ds-heart'); heart.type = 'button'; heart.dataset.favorite = handle;
      heart.innerHTML = '<svg viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1.1-1.1a5.5 5.5 0 0 0-7.8 7.8L12 21l8.8-8.6a5.5 5.5 0 0 0 0-7.8Z"/></svg>';
      card.append(heart);
      if (result.status === 'rejected') { missing++; card.append(element('h2', '', 'Pattern unavailable'), element('p', '', 'This pattern could not be loaded. Try again later or remove it from your favorites.')); }
      else {
        const product = result.value; const url = window.K2View ? window.K2View.homeURL(handle) : `${root}?focus_product=${encodeURIComponent(handle)}#Pattern-${encodeURIComponent(handle)}`;
        const link = element('a', 'ds-favorite-image'); link.href = url; link.dataset.homeProduct = handle;
        const src = safeImage(product.featured_image || product.images?.[0]);
        if (src) { const image = element('img'); image.src = src; image.alt = product.title; image.loading = 'lazy'; image.width = 450; image.height = 600; link.append(image); }
        else link.textContent = product.title;
        const heading = element('h2'); const title = element('a', '', product.title); title.href = url; title.dataset.homeProduct = handle; heading.append(title);
        const action = element('a', 'ds-button', 'Find on home page →'); action.href = url; action.dataset.homeProduct = handle;
        const currency = page.dataset.currency || 'USD';
        const price = new Intl.NumberFormat(document.documentElement.lang || 'en', {style: 'currency', currency}).format(product.price / 100);
        card.append(link, element('p', 'ds-tag', 'DIGITAL SEWING PATTERN'), heading, element('p', '', `${product.price_varies ? 'From ' : ''}${price}`), action);
      }
      grid.append(card);
    });
    status.textContent = missing ? 'Some saved patterns are currently unavailable.' : '';
    syncHearts();
  }
  async function requestCart(path, body) {
    const response = await fetch(`${root}${path}`, {method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'}, body: JSON.stringify(body)});
    const data = await response.json();
    if (!response.ok || data.status >= 400) throw new Error(data.description || data.message || 'Unable to update your bag. Please try again.');
    return data;
  }
  const readCart = () => document.querySelector('[data-digital-cart]');
  const consentState = cart => Array.from(cart.querySelectorAll('[data-consent]'));
  function updateCheckout(cart) {
    if (!cart) return;
    const eligible = cart.dataset.signedIn === 'true' && cart.dataset.profileComplete === 'true';
    consentState(cart).forEach(input => { input.disabled = !eligible; if (!eligible) input.checked = false; });
    const button = cart.querySelector('[data-checkout-button]');
    if (button) button.disabled = !eligible || !consentState(cart).every(input => input.checked) || cart.getAttribute('aria-busy') === 'true';
  }
  function cartMessage(text, error = false) {
    const node = readCart()?.querySelector('[data-cart-message]');
    if (!node) return;
    node.textContent = text; node.hidden = !text; node.dataset.error = String(error);
    if (text && error) { node.scrollIntoView({block:'center',behavior:'smooth'}); node.focus({preventScroll:true}); }
  }
  function requireCartProfile(cart) {
    if (!cart || cart.dataset.designMode === 'true' || cart.dataset.signedIn !== 'true' || cart.dataset.profileComplete === 'true' || !cart.querySelector('[data-digital-checkout]')) return;
    location.replace(cart.dataset.profileUrl);
  }
  async function refreshCart() {
    const current = readCart(); if (!current) return;
    const response = await fetch(`${root}cart?section_id=${encodeURIComponent(current.dataset.section)}`, {credentials:'same-origin',cache:'no-store'});
    if (!response.ok) throw new Error('Your bag was updated. Refresh the page to see the latest totals.');
    const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
    const next = doc.querySelector('[data-digital-cart]');
    if (!next) throw new Error('Refresh the page to see the latest totals.');
    current.replaceWith(next); window.K2Gifts?.render(); updateCheckout(next); requireCartProfile(next); syncHearts();
    const count = Number(next.querySelector('.ds-count')?.textContent || 0);
    const bubble = document.querySelector('#cart-icon-bubble .cart-count-bubble');
    if (bubble) { bubble.hidden = count === 0; const visible = bubble.querySelector('[aria-hidden=true]'); if (visible) visible.textContent = count; const label = bubble.querySelector('.visually-hidden'); if (label) label.textContent = `${count} items`; }
  }
  function discountMessage(text, error, code) {
    const form = readCart()?.querySelector('[data-discount-form]');
    if (!form) return;
    const input = form.elements.discount;
    input.value = code;
    input.setAttribute('aria-invalid', String(error));
    const status = form.querySelector('[data-discount-message]');
    status.hidden = false;
    status.textContent = text;
    status.dataset.state = error ? 'error' : 'success';
  }
  function discountResult(data, code) {
    const same = value => typeof value === 'string' && value.toLowerCase() === code.toLowerCase();
    const match = data.discount_codes?.find(entry => same(entry.code));
    if (match) return match.applicable === true;
    return Boolean(data.cart_level_discount_applications?.some(item => item.type === 'discount_code' && same(item.title)) || data.items?.some(item => item.line_level_discount_allocations?.some(({discount_application: d}) => d?.type === 'discount_code' && same(d.title))));
  }
  async function mutateCart(path, body, message, discountCode) {
    const cart = readCart(); if (!cart || cart.getAttribute('aria-busy') === 'true') return;
    cart.setAttribute('aria-busy', 'true'); updateCheckout(cart); cartMessage('Updating your bag…');
    try {
      const data = await requestCart(path, body);
      await refreshCart();
      if (await window.K2Gifts?.reconcile()) await refreshCart();
      if (discountCode !== undefined) {
        const applied = discountResult(data, discountCode);
        discountMessage(applied ? 'Discount applied.' : 'This discount code is invalid or cannot be used with your current bag.', !applied, discountCode);
        cartMessage('');
      } else cartMessage(message || 'Bag updated. Please confirm your choices before checkout.');
    } catch (error) {
      if (discountCode !== undefined) discountMessage('We could not verify this code. Please try again.', true, discountCode);
      cartMessage(error.message, true);
    }
    finally { const active = readCart(); active?.removeAttribute('aria-busy'); updateCheckout(active); }
  }
  document.addEventListener('change', event => {
    if (event.target.matches('[data-consent]')) updateCheckout(readCart());
    const input = event.target.closest('[data-quantity]'); if (!input) return;
    if (readCart()?.getAttribute('aria-busy') === 'true') return;
    if (!input.checkValidity() || !Number.isInteger(Number(input.value))) { input.reportValidity(); return; }
    mutateCart('cart/change.js', {id: input.dataset.key, quantity: Number(input.value)});
  });
  document.addEventListener('click', event => {
    const remove = event.target.closest('[data-remove]');
    if (remove) { event.preventDefault(); mutateCart('cart/change.js', {id: remove.dataset.key, quantity: 0}); }
    if (event.target.closest('[data-clear-discounts]')) { event.preventDefault(); mutateCart('cart/update.js', {discount: ''}, 'Discount codes removed.'); }
  });
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (form.matches('[data-discount-form]')) {
      event.preventDefault(); const code = form.elements.discount.value.trim(); if (!code) return;
      await mutateCart('cart/update.js', {discount: code}, null, code);
    }
    if (form.matches('[data-digital-checkout]')) {
      event.preventDefault(); const cart = readCart();
      if (!cart || cart.dataset.signedIn !== 'true' || cart.getAttribute('aria-busy') === 'true') return;
      if (cart.dataset.profileComplete !== 'true') { requireCartProfile(cart); return; }
      if (!form.reportValidity() || !consentState(cart).every(input => input.checked)) return;
      cart.setAttribute('aria-busy', 'true'); updateCheckout(cart);
      const attributes = Object.fromEntries(consentState(cart).map(input => [input.name.slice(11, -1), input.value]));
      attributes['Digital consent timestamp UTC'] = new Date().toISOString();
      attributes['Digital consent wording version'] = '2026-09-21-v1';
      try {
        // Read the signed-in Shopify customer's name from a fresh Liquid section.
        // This is a storefront UX gate; Shopify checkout itself is managed by Shopify.
        const profileResponse = await fetch(`${root}cart?section_id=${encodeURIComponent(cart.dataset.section)}`, {credentials:'same-origin',cache:'no-store'});
        if (!profileResponse.ok) throw new Error('Your Shopify profile could not be checked. Please try again.');
        const profileDoc = new DOMParser().parseFromString(await profileResponse.text(), 'text/html');
        const profileCart = profileDoc.querySelector('[data-digital-cart]');
        if (!profileCart) throw new Error('Your Shopify profile could not be checked. Please refresh the page.');
        if (profileCart.dataset.signedIn !== 'true' || profileCart.dataset.profileComplete !== 'true') {
          cart.dataset.signedIn = profileCart.dataset.signedIn;
          cart.dataset.profileComplete = profileCart.dataset.profileComplete;
          updateCheckout(cart);
          cartMessage('Please sign in and complete your first and last name before checkout.', true);
          location.assign(cart.dataset.profileUrl); return;
        }
        if (await window.K2Gifts?.reconcile()) { await refreshCart(); throw new Error('Your gift selection changed. Review your bag and confirm your choices again.'); }
        await requestCart('cart/update.js', {attributes});
        // Native cart checkout keeps the Shopify checkout flow; no card details enter this theme.
        const checkout = element('input'); checkout.type = 'hidden'; checkout.name = 'checkout'; checkout.value = 'Checkout'; form.append(checkout);
        HTMLFormElement.prototype.submit.call(form);
      } catch (error) { cart.removeAttribute('aria-busy'); updateCheckout(cart); cartMessage(error.message, true); }
    }
  });
  function showInformation() {
    const page = document.querySelector('[data-information-page]'); if (!page) return;
    const panels = [...page.querySelectorAll('[data-information-panel]')];
    const key = location.hash.slice(1); const active = panels.find(panel => panel.id === key) || panels[0];
    panels.forEach(panel => { panel.hidden = panel !== active; });
    page.querySelectorAll('nav a').forEach(link => { if (link.hash === `#${active.id}`) link.setAttribute('aria-current', 'page'); else link.removeAttribute('aria-current'); });
  }
  window.addEventListener('hashchange', showInformation);
  window.addEventListener('pageshow', () => { const cart = readCart(); if (cart) { cart.removeAttribute('aria-busy'); consentState(cart).forEach(input => { input.checked = false; }); updateCheckout(cart); requireCartProfile(cart); } });
  document.addEventListener('shopify:section:load', () => { syncHearts(); updateCheckout(readCart()); showInformation(); renderFavorites(); });
  // New cards can arrive through Shopify search, quick-add and section rendering.
  const observer = new MutationObserver(records => { if (records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches?.('[data-favorite]') || node.querySelector?.('[data-favorite]'))))) syncHearts(); });
  observer.observe(document.body, {childList: true, subtree: true});
  window.K2Cart = { mutate: mutateCart, refresh: refreshCart };
  if (readCart()) window.K2Gifts?.reconcile().then(async changed => { if (changed) await refreshCart(); }).catch(error => cartMessage(error.message));
  syncHearts(); updateCheckout(readCart()); requireCartProfile(readCart()); renderFavorites(); showInformation();
})();
